import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  SimpleDataTable as DataTable,
  Loader,
  ButtonOBSOLETED,
  Notification,
  Message
} from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import { Filters, FilterInput, FilterSelect, FilterSelectAsync, FilterTimePicker } from './Filters';
import { getQueryStringParameters } from '../../common/utils';
import { purchaseStatus } from '../../enums/purchaseStatus';
import {
  DisplayCurrencyAmount,
  DisplayDate,
  DisplayGuid,
  DisplayStatus
} from '../items';

const resultsCount = 15;

class PurchasesInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  componentDidMount() {
  }

  goToPage(number) {
    // TODO consider to move responsability to filter component
    const { history, location } = this.props;
    const filters = Object.assign(
      {},
      getQueryStringParameters(location.search),
      {
        page: number
      });
    const search = Object.keys(filters)
      .filter(key => key && filters[key])
      .map(key => `${key}=${encodeURIComponent(filters[key])}`).join('&');
    history.push(`?${search}`);
  }

  async loadData(filters, skipPages) {
    const { props: { api: { purchases: { searchPurchase } } } } = this;

    this.setState({ isLoading: true });
    let result = null;

    try {
      result = await searchPurchase({ filters, skipPages, resultsCount });
    }
    catch (e) {
      console.error(`unable to load. ${e}`);
      this.setState({ isLoading: false, errorMessage: new Message('error', 'Unable to load data') });

      return;
    }

    this.setState({ isLoading: false });

    return result;
  }

  render() {
    const { location } = this.props;
    const { isLoading, errorMessage } = this.state;
    const parameters = getQueryStringParameters(location.search);
    const pageNumber = parameters.page ? parseInt(parameters.page, 10) : 1;
    const { history, api } = this.props;
    const { users: { lookupByEmailOrId } } = api;

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />
            <PageTop
              documentTitle='Purchases page'
              documentDescription='Purchases page'
            />

            <h2 className='main-page-header'>Purchases</h2>

            <Filters
              initFromUrl
              submitUrl
              validateForm={({
                purchaseId,
                productId,
                reference,
                status,
                userId,
                afterAt,
                beforeAt
              }, updatedKey) => {
                if (updatedKey !== 'purchaseId') {
                  return {
                    productId,
                    reference,
                    status,
                    userId,
                    afterAt,
                    beforeAt
                  };
                }
                return { purchaseId };
              }}
              render={(formData, update) => (
                <div className='filters-block'>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='purchaseId'>
                      Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='purchaseId'
                      placeholder='Find by id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='productId'>
                      Product Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='productId'
                      placeholder='Filter by product id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='purchaseId'>
                      Reference
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='reference'
                      placeholder='Filter by reference'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='userId'>
                      User
                    </label>
                    <FilterSelectAsync
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='userId'
                      loadOptions={async inputValue => lookupByEmailOrId(inputValue)}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='afterAt'>
                      From
                    </label>
                    <FilterTimePicker
                      className='filter-date-picker'
                      data={formData}
                      update={update}
                      name='afterAt'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='beforeAt'>
                      To
                    </label>
                    <FilterTimePicker
                      className='filter-date-picker'
                      data={formData}
                      update={update}
                      name='beforeAt'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='status'>
                      Status
                    </label>
                    <FilterSelect
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='status'
                      options={purchaseStatus}
                    />
                  </div>
                  <br />
                  <br />
                  <div className='filters-submit-wrapper'>
                    <ButtonOBSOLETED type='submit' buttonContent='Search' disabled={isLoading} />
                  </div>
                  <hr />
                </div>
              )}
            />
            <DataTable
              style={{ marginTop: '100px' }}
              loadingContent={(<Loader hasLoaded={false} />)}
              tableConfig={{
                tableName: 'purchases',
                rowClasses: 'hover-listview ',
                rowClick: ({ Id }) => {
                  history.push(`/purchase/${Id}`);
                },
                columns: [
                  {
                    property: 'Id',
                    label: 'Id',
                    render: ({ Id }) => <DisplayGuid>{Id}</DisplayGuid>
                  },
                   {
                    property: 'Reference',
                    label: 'Reference'
                  }, {
                    property: 'Text',
                    label: 'Text'
                  },{
                    property: 'Status',
                    label: 'Status',
                    render: ({ Status }) => <DisplayStatus mapping={purchaseStatus}>{Status}</DisplayStatus>
                  },{
                    property: 'Total',
                    label: 'Total',
                    render: ({ Total: { Amount, CurrencyIsoCode } }) =>
                      <DisplayCurrencyAmount amount={Amount} alignRight currency={CurrencyIsoCode} />
                  }, {
                    property: 'Created At (CET)',
                    label: 'Created At (CET)',
                    render: ({ CreatedAtCet }) => <DisplayDate>{CreatedAtCet}</DisplayDate>
                  }, {
                    property: 'Occurs At (CET)',
                    label: 'Occurs At (CET)',
                    render: ({ OccursAtCet }) => <DisplayDate>{OccursAtCet}</DisplayDate>
                  }
                ]
              }}
              getData={async newPageNumber => {
                const filters = getQueryStringParameters(location.search);

                return this.loadData(filters, newPageNumber || 1);
              }}
              paginationData={{
                renderLocation: 'both',
                rowsPerPage: resultsCount,
                pageNumber,
                goToPageNumber: number => this.goToPage(number)
              }}
              skipTableNoResults
              cellVerticalAlign='top'
              hideTableHead={false}
              languageCode='en'
              labels={{
                tableBody: {
                  noResult: <div style={{ display: 'block', textAlign: 'center' }}>No Results</div>
                }
              }}
              cellContent='cellContent'
            />
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Purchases = withRouter(withApi(
  connect(({ user }) => ({ isLoggedIn: !!user }), {})(PurchasesInternal)
));

Purchases.requiresLogin = true;
Purchases.propTypes = { isLoggedIn: PropTypes.bool };

export default Purchases;
